const shadowDomElementRegistry = new Map();
export function registerShadowDomElement(id, element) {
    shadowDomElementRegistry.set(id, element);
}
export function unregisterShadowDomElement(id) {
    shadowDomElementRegistry.delete(id);
}
export function getShadowDomElement(id) {
    return shadowDomElementRegistry.get(id) ?? null;
}
//# sourceMappingURL=shadow-dom-element-registry.js.map